import React, { Component } from 'react';
import './Resume.scss';

const resume_items = {
  "sections": [
    { "title": "PAST WORK",
      "items": [
        { "name" : "SwiftMobile / GeoGo",
          "date" : "2008 - 2015",
          "title": "CTO",
          "desc" : "Developed the native mobile apps and server infrastructure for hundreds of large events, trade shows and convention centers. Worked as part of the senior management team to develop company strategy, identify customers, and manage a distributed team of developers.",
        },
        { "name" : "Jack Morton Worldwide",
          "date" : "2000 - 2008",
          "title": "Sr. Technology Director",
          "desc" : "Developed, designed and executed online communication plans and architecture for clients of the Digital group within this leading experiential marketing agency. Led the technical team to deliver innovative, well-targeted, business-building technology solutions. Tracked and responded to changes within the digital and new media landscape, educated clients and internal teams on appropriate technologies.",
        },
        { "name" : "Planet Interactive",
          "date" : "1993 - 1999",
          "title": "Co-Founder",
          "desc" : "Led a talented group of developers to deliver digital media and websites, online marketing campaigns, and retail installations for corporate and museum clients.",
        },
        { "name" : "Interactive Factory",
          "date" : "1992 - 1993",
          "title": "Partner",
          "desc" : "Early member of this group of artists, developers, and visionaries exploring the limits of interactive digital media and the new Internet.",
        }
      ]
    },
    { "title": "START-UPS",
      "items": [
        { "name" : "Smart Agenda",
          "date" : "2017 - Present",
          "title" : "Co-Founder",
          "desc" : "Design & develop a realtime collaborative web application for meeting participants.",
        },
        { "name" : "Monkey Wrench Technology",
          "date" : "2014 - 2017",
          "title" : "CTO",
          "desc" : "Developed the technology platform for the BarBot inventory management app.",
        },
        { "name" : "First Circles",
          "date" : "2016 - 2017",
          "title" : "CTO",
          "desc" : "Developed the native mobile apps and server infrastructure for this group, which helps support disabled adults living independently.",
        },
        { "name" : "Impact Mapper",
          "date" : "2016 - 2017",
          "title" : "Developer",
          "desc" : "Updated the client code and maintained servers for this tool that helps NGOs manage their donations in the developing world.",
        }
      ]
    },
    { "title": "EDUCATION",
      "items": [
        { "name" : "Princeton University",
          "date" : "1979 – 1983",
          "desc" : "Computer Science and Electrical Engineering",
        }
      ]
    }
  ]
};

export default class Resume extends Component {

  renderSections(parent, items) {
    return items.sections.map(function(section, i) {
      return (
        <div key={i} className="col-sm-6 col-xs-12">
            <div className="resume-box">
              <h4>{section.title}</h4>
              {parent.renderItems(section.items)}
            </div>
         </div>
      );
    })
  }

  renderItems(items) {
    return items.map(function(item, j) {
      return (
        <div key={j} className="resume-row">
          <h5>{item.name}</h5>
          <label>{item.date}</label>
          <p>{item.desc}</p>
        </div>
      );
    })
  }

  render() {
    return (
      <section id="resume" className="section">
        <div className="container">
          <div className="section-title">
            <h2><span>My</span> Experience</h2>
          </div>

          <div className="row">
            {this.renderSections(this, resume_items)}
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Resume.js